module.exports = __webpack_public_path__ + "img/clients-05.df5747cd.svg";